<div style="background-image: url('../../../../assets/imagesNew/Proceed2.png') !important; background-size: cover; height: 100vh;" >


    <span style="color: white; float: right; margin: 4% 7%; position: relative;"> <h6>V{{version}}</h6> </span>


    <div *ngIf="!(practices.length == 1)">
        <p-dialog [(visible)]="displaypopup"
                  [draggable]="false"
                  [modal]="true"
                  positionType="absolute"
                  [closable]="false"
                  [maximizable]="false"
                  [style]="{ width: '90%', 'max-width': '450px' }">
            <p-header>
                <!--{{popupheader}}-->
                <h2 class="mb-0"
                    style="font-weight: unset !important; font-size: larger !important">
                    Choose Practice
                </h2>
            </p-header>

            <div class="grid">
                <div class="col-12 p-md12">
                    <div class="row">
                        <div class="col-12">
                            <label style="
            color: black;
            font-size: large;
            font-family: Arial, Helvetica, sans-serif;
            padding: 0px 15px;
          ">Select Practice:</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12"
                             style="
          color: black;
          font-size: large;
          font-family: Arial, Helvetica, sans-serif;
          padding: 0px 15px;
        ">
                            <select id="practiceControl"
                                    class="p-dropdown w-full"
                                    style="padding-left: 20px !important; border: none"
                                    [formControl]="practiceControl">
                                <option *ngFor="let item of practices"
                                        [value]="item.practiceid"
                                        class="form-control input-lg">
                                    <div class="m-3">
                                        {{ item.name }}
                                    </div>
                                </option>
                            </select>

                            <!--<p-dropdown *ngIf="practices" appendTo="body" dataKey="practiceid" [options]="practices" formControlName="practiceControl" optionLabel="name" [showClear]="true" placeholder="Select a Practice" class="p-dropdown w-full"></p-dropdown>-->
                        </div>
                    </div>
                </div>
            </div>

            <p-footer style="display: flex; justify-content: center">
                <button type="button"
                        icon="pi pi-check"
                        label="OK"
                        (click)="onPracticeSelected()"
                        class="btn form-control input-lg loginbtn">
                    Continue
                </button>
            </p-footer>
        </p-dialog>

    </div>
    

    <p-dialog header="Practice Message"
              [(visible)]="showPracticeMessage"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '80vw' }">
        <div [innerHtml]="practiceMessage"></div>

        <div class="flex flex-row-reverse">
            <p-button label="OK"
                      (click)="navigateToDashboard(practiceControl.value, true)"></p-button>
        </div>
    </p-dialog>
</div>
